import { useState, useEffect } from "react";
import axios from "axios";
import ApplyModal from "./ApplyModal";
import "./careers.css";

export default function Internships() {
  const [internships, setInternships] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInternship, setSelectedInternship] = useState("");

  // Fetch internships from MongoDB via your Backend API
  useEffect(() => {
    const fetchInternships = async () => {
      try {
        const response = await axios.get("https://meetra-green-energy-backend.onrender.com/api/openings");
        // Filter to only show internships
        const onlyInternships = response.data.filter((item) => item.type === "internship");
        setInternships(onlyInternships);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching internships:", error);
        setLoading(false);
      }
    };
    fetchInternships();
  }, []);

  const openModal = (title) => {
    setSelectedInternship(title);
    setIsModalOpen(true);
  };

  return (
    <div className="career-page">
      <h1>Internships</h1>
      <p>Learn, grow, and work on real solar projects ☀️</p>

      {loading ? (
        <p>Loading internships...</p>
      ) : internships.length > 0 ? (
        internships.map((intern) => (
          <div className="job-card" key={intern._id}>
            <h3>{intern.title}</h3>
            <p><strong>Location:</strong> {intern.location}</p>
            <p><strong>Mode:</strong> {intern.mode}</p>
            <p><strong>Duration:</strong> {intern.duration}</p>
            <button onClick={() => openModal(intern.title)}>
              Apply Now
            </button>
          </div>
        ))
      ) : (
        <p>No internships available currently. Keep an eye out!</p>
      )}

      {/* APPLY MODAL */}
      <ApplyModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        jobTitle={selectedInternship}
      />
    </div>
  );
}